

























import { Component, Mixins } from "vue-property-decorator";
import { DeveloperIndicator } from "./developer";
import { default as SuspendedPresentableMixin } from "./SuspendedPresentableMixin.vue";

@Component({
  components: {
    DeveloperIndicator,
  }
})
export default class WarningView extends Mixins(SuspendedPresentableMixin) {
  get shouldShowDetail(): boolean {
    return this.isDeveloperMode;
  }

  created(): void {
    console.warn("エラーによって処理を中断しました。");
    console.warn(this.url);
    console.warn(this.message);
  }

  get warningTitle(): string {
    return this.title ? this.title : "エラー";
  }
}
